<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="true"
    custom-class="zyyj-dialog"
    :close-on-click-modal="false"
    @open="handleOpen"
  >
    <div id="login-container">
      <span class="forget-pass">登录密码更改</span>

      <el-form
        key="passForm"
        ref="passForm"
        :model="passForm"
        :rules="passRule"
        class="login-form"
        label-position="top"
        v-loading="loading"
      >
        <el-form-item prop="password" key="password">
          <label for="password" class="common-label">新密码</label>
          <el-input
            type="password"
            v-model="passForm.password"
            auto-complete="off"
            :maxlength="20"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="checkPassword" key="checkPassword">
          <label for="checkPassword" class="common-label">确认新密码</label>
          <el-input
            type="password"
            id="checkPassword"
            v-model="passForm.checkPassword"
            auto-complete="off"
            :maxlength="20"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="button" style="width: 100%">
          <el-button type="primary" class="next-button" @click="checkPwd"
            >重新登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import md5 from 'js-md5'

export default {
  props: ['visible', 'schoolName'],
  data () {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/.test(value) === false) {
          callback(new Error('密码包含大小写字母、数字、特殊字符，至少8位'))
        } else {
          callback()
        }
        if (this.passForm.checkPassword !== '') {
          this.$refs.passForm.validateField('checkPassword')
        }
        callback()
      }
    }
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passForm.password) {
        callback(new Error('两次密码输入不一致，请重新输入'))
      } else if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,20}$/.test(value) === false) {
        callback(new Error('密码仅支持包含英文字母和数字'))
      } else {
        callback()
      }
    }
    return {
      step: 2,
      checkRule: {
        school: [{ required: true, trigger: 'blur' }]
      },
      passRule: {
        password: [
          { validator: validatePass, trigger: 'blur' },
          { min: 6, message: '长度至少 8 个字符', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePassword, trigger: 'blur' },
          { min: 6, message: '长度至少 8 个字符', trigger: 'blur' },
          { max: 20, message: '长度最多 20 个字符', trigger: 'blur' }
        ]
      },
      checkForm: { school: '111' },
      passForm: { password: '', checkPassword: '' },
      loading: false,
      errorMsg: ''
    }
  },

  computed: {
    dialogVisible: {
      get () {
        return this.visible === true
      },
      set () {
        this.$emit('update:visible', false)
      }
    }
  },

  mounted () {
  },

  methods: {
    handleOpen () {
      this.step = 1
      this.checkForm.school = this.schoolName
      this.passForm = { password: '', checkPassword: '' }
    },
    closeDialog () {
      this.$emit('update:visible', false)
      this.$emit('change-succ')
    },
    checkAccount () {
      this.$refs['checkForm'].validate(valid => {
        if (valid) {
          this.$xhrGet('/acc/identity/verification').then(rs => {
            if (rs.code === 'SUCCESS') {
              this.loading = true
              this.step = 2
              setTimeout(() => {
                this.$refs.checkForm && this.$refs.checkForm.resetFields()
                this.$refs.passForm && this.$refs.passForm.resetFields()
              }, 10)
              setTimeout(() => {
                this.loading = false
              }, 400)
            }
          })
        }
      })
    },
    checkPwd () {
      this.$refs['passForm'].validate(valid => {
        if (valid) {
          this.$xhrPatch('/acc/admin/password/reset', {
            password: md5(this.passForm.password + 'p@w123!@#')
          }).then(rs => {
            this.loading = false
            if (rs.code === 'SUCCESS' && !rs.data) {
              this.loading = true
              this.$message.success('管理员密码修改成功，请重新登录')
              this.login()
            } else if (rs.code === 'auth_timeout') {
              this.$message.error('密码修改已超时，请重新登录')
              this.login()
            } else if (rs.code === 'password_modified') {
              this.$message.error('当前登录账号密码已重置，请重新登录')
              this.login()
            } else if (rs.code === 'illegal_password') {
              this.$message.error('修改后的密码不能与原密码相同')
            }
          })
        }
      })
    },
    login () {
      setTimeout(() => {
        this.closeDialog()
        localStorage.clear()
        // 页面刷新
        window.location.reload()
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
#login-container {
  width: 100%;
  height: 450px;
}
.login-form {
  background-clip: padding-box;
  background: #fff;
  margin: 40px auto 40px auto;
  width: 40%;
}
.login-tips p {
  line-height: 15px;
}
.forget-pwd {
  color: #5d94f3;
  font-size: 14px;
  text-align: right;
  margin: 0px auto;
  cursor: pointer;
}
.span-button {
  color: #5e93f6;
  cursor: pointer;
  font-size: 14px;
}
.el-form /deep/ .el-button.is-plain {
  background: #fff;
}
.el-form /deep/ .el-button.is-plain:hover {
  background: #eff4fe;
  color: #5e93f6;
}
.captcha /deep/ .el-input__inner {
  z-index: 1;
}
#login-container /deep/ button.captcha {
  border-radius: 0;
}
/deep/ .el-input {
  width: 100%;
}
/deep/ .el-input__inner {
  width: 100%;
  padding-left: 0;
  border-radius: 0;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
}
.common-label {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #444444;
}
.row {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  height: 100%;
  padding: 100px 200px;
}
.title {
  height: 42px;
  font-size: 30px;
  font-weight: 500;
  color: #444444;
  line-height: 42px;
}
.form-column {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px rgba(33, 33, 33, 0.12);
}
.forget-pass {
  display: inline-block;
  width: 100%;
  height: 33px;
  margin: 40px auto 0 auto;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  color: #4a4a4a;
  line-height: 33px;
}
.get-captcha {
  font-size: 16px;
  font-weight: 400;
  color: var(--theme-color);
}
.next-button {
  width: 100%;
  background: var(--theme-color);
  border-radius: 20px;
  margin-top: 10px;
}
.el-step /deep/ .el-step__icon {
  border: none;
}
/deep/ .is-process {
  color: #9b9b9b !important;
}
.second-step /deep/ .is-finish {
  color: #9b9b9b !important;
}
/deep/ .el-step__title {
  font-size: 14px;
}
/deep/ .el-step__line-inner {
  border-color: #cccccc !important;
}
/deep/ input::-webkit-input-placeholder {
  /* 修改字号，默认继承input */
  font-size: 16px;
}
.button /deep/ .el-form-item__content {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/change-pass-editor/change-pass-editor.vue